import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.MIX_REVERB_APP_KEY,
    wsHost: process.env.MIX_REVERB_HOST,
    wsPort: process.env.MIX_REVERB_PORT,
    wssPort: process.env.MIX_REVERB_PORT,
    forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    // Use Axios for channel auth so expired sessions redirect to login instead of failing silently.
    // Pusher-js uses its own XHR by default which swallows auth errors.
    authorizer: (channel) => ({
        authorize: (socketId, callback) => {
            window.axios
                .post('/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                .then((response) => {
                    callback(null, response.data);
                })
                .catch((error) => {
                    const status = error.response?.status;
                    if (
                        (status === 401 || status === 403) &&
                        !window.location.pathname.startsWith('/login')
                    ) {
                        window.location.href = '/login';
                    }
                    callback(true, error);
                });
        },
    }),
});
